import Select, { type SelectProps } from '@rio-cloud/rio-uikit/Select';
import { getMonth, getYear, subMonths } from 'date-fns';

import type { UsageSelectOption } from './types';

interface UsageMonthSelectorProps extends SelectProps<UsageSelectOption> {
    selectYearAndMonth: (year: number, month: number) => void;
    year: number;
    month: number;
}

const selectOptions: UsageSelectOption[] = Array.from({ length: 48 }, (_, i) => {
    const date = subMonths(new Date(), i);
    const year = getYear(date);
    const month = getMonth(date) + 1;
    return {
        id: `${year}-${month}`,
        label: `${month} / ${year}`,
        month: month,
        year: year,
    };
});

export const UsageMonthSelector = (props: UsageMonthSelectorProps) => {
    const { selectYearAndMonth, year, month, ...rest } = props;

    return (
        <Select
            className={'min-width-150'}
            options={selectOptions}
            onChange={item => item && selectYearAndMonth(item.year, item.month)}
            value={[`${year}-${month}`]}
            {...rest}
        />
    );
};
